import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import {
  createWashingHistoryApi,
  deleteMachinePart,
  getAllMachinePart,
  getRecentWashingHistoryApi,
} from '@/apis/machinePart'
import useNotification from '@/hooks/useNotification'
import { MachinePartHistory } from '@/types'
import { DeleteIdCardRequest } from '@/types/apis/idCards'
import { GetAllMachinePartsResponse } from '@/types/apis/machineParts/GetAllMachinePartsResponse'

export const useMachineParts = () => {
  const { t } = useTranslation()
  const openNotification = useNotification()
  const [getMachinePartsLoading, setGetMachinePartsLoading] = useState(false)
  const [getMachinePartsResponse, setMachinePartsResponse] = useState<GetAllMachinePartsResponse>()
  const [deleteMachinePartLoading, setDeleteMachinePartLoading] = useState(false)
  const [recentHistoryResponse, setRecentHistoryResponse] = useState<MachinePartHistory[]>()

  const get = useCallback(async (id: number) => {
    try {
      setGetMachinePartsLoading(true)
      const res = await getAllMachinePart({ id })

      setMachinePartsResponse(res)
    } finally {
      setGetMachinePartsLoading(false)
    }
  }, [])

  const del = useCallback(
    async ({ id }: DeleteIdCardRequest) => {
      try {
        setDeleteMachinePartLoading(true)
        await deleteMachinePart({ id })

        openNotification({ type: 'success', description: t('components.pages.admins.common.delete.success') })
      } catch {
        openNotification({ type: 'error', description: t('components.pages.admins.common.delete.fail') })
      } finally {
        setDeleteMachinePartLoading(false)
      }
    },
    [openNotification, t]
  )

  const createWashingHistory = useCallback(
    async (id: number) => {
      try {
        await createWashingHistoryApi(id)

        openNotification({ type: 'success', description: t('components.pages.admins.common.create.success') })
      } catch {
        openNotification({ type: 'error', description: t('components.pages.admins.common.create.fail') })
      }
    },
    [openNotification, t]
  )

  const getRecentHistory = useCallback(async (machineId: number) => {
    try {
      const response = await getRecentWashingHistoryApi(machineId)

      setRecentHistoryResponse(response)
    } catch {
      // do nothing
    }
  }, [])

  return {
    getMachineParts: get,
    getMachinePartsResponse,
    getMachinePartsLoading,
    deleteMachinePart: del,
    deleteMachinePartLoading,
    createWashingHistory,
    getRecentHistory,
    recentHistoryResponse,
  }
}
